export const minnesota = {
  "27000": "Minnesota",
  "27001": "Aitkin County",
  "27003": "Anoka County",
  "27005": "Becker County",
  "27007": "Beltrami County",
  "27009": "Benton County",
  "27011": "Big Stone County",
  "27013": "Blue Earth County",
  "27015": "Brown County",
  "27017": "Carlton County",
  "27019": "Carver County",
  "27021": "Cass County",
  "27023": "Chippewa County",
  "27025": "Chisago County",
  "27027": "Clay County",
  "27029": "Clearwater County",
  "27031": "Cook County",
  "27033": "Cottonwood County",
  "27035": "Crow Wing County",
  "27037": "Dakota County",
  "27039": "Dodge County",
  "27041": "Douglas County",
  "27043": "Faribault County",
  "27045": "Fillmore County",
  "27047": "Freeborn County",
  "27049": "Goodhue County",
  "27051": "Grant County",
  "27053": "Hennepin County",
  "27055": "Houston County",
  "27057": "Hubbard County",
  "27059": "Isanti County",
  "27061": "Itasca County",
  "27063": "Jackson County",
  "27065": "Kanabec County",
  "27067": "Kandiyohi County",
  "27069": "Kittson County",
  "27071": "Koochiching County",
  "27073": "Lac qui Parle County",
  "27075": "Lake County",
  "27077": "Lake of the Woods County",
  "27079": "Le Sueur County",
  "27081": "Lincoln County",
  "27083": "Lyon County",
  "27085": "McLeod County",
  "27087": "Mahnomen County",
  "27089": "Marshall County",
  "27091": "Martin County",
  "27093": "Meeker County",
  "27095": "Mille Lacs County",
  "27097": "Morrison County",
  "27099": "Mower County",
  "27101": "Murray County",
  "27103": "Nicollet County",
  "27105": "Nobles County",
  "27107": "Norman County",
  "27109": "Olmsted County",
  "27111": "Otter Tail County",
  "27113": "Pennington County",
  "27115": "Pine County",
  "27117": "Pipestone County",
  "27119": "Polk County",
  "27121": "Pope County",
  "27123": "Ramsey County",
  "27125": "Red Lake County",
  "27127": "Redwood County",
  "27129": "Renville County",
  "27131": "Rice County",
  "27133": "Rock County",
  "27135": "Roseau County",
  "27137": "St. Louis County",
  "27139": "Scott County",
  "27141": "Sherburne County",
  "27143": "Sibley County",
  "27145": "Stearns County",
  "27147": "Steele County",
  "27149": "Stevens County",
  "27151": "Swift County",
  "27153": "Todd County",
  "27155": "Traverse County",
  "27157": "Wabasha County",
  "27159": "Wadena County",
  "27161": "Waseca County",
  "27163": "Washington County",
  "27165": "Watonwan County",
  "27167": "Wilkin County",
  "27169": "Winona County",
  "27171": "Wright County",
  "27173": "Yellow Medicine County",
};
